export const iconFontAwesomeChildhoodPersonBreastfeeding = (
	<i className="fa-solid fa-person-breastfeeding"></i>
);
